export const supplementaryCardInstallments = {
    enabled: false,
    _description: 'Enables the supplementary card installments feature',
};
